// extracted by mini-css-extract-plugin
module.exports = {"text404":"styles_text404__QaxCd","big":"styles_big__1QhOm","link":"styles_link__lQeks"};